import { render } from "./ViewDeleteModal.vue?vue&type=template&id=50aa8b65&scoped=true&ts=true"
import script from "./ViewDeleteModal.vue?vue&type=script&lang=ts"
export * from "./ViewDeleteModal.vue?vue&type=script&lang=ts"

import "./ViewDeleteModal.vue?vue&type=style&index=0&id=50aa8b65&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50aa8b65"]])

export default __exports__